import { Config } from "../config/companies/config";
import { getConfig } from "../config/config";
import {
  applyRoleConfig,
  CompanyRoleConfig,
  removeUndefined,
} from "../config/companies/roleConfig";
import { getDocument, update } from "./firestoreServices";

const COMPANIES_COLLECTION = "companies";

export const getCompanyRoleConfig = async (
  companyId?: string,
): Promise<CompanyRoleConfig | null> => {
  if (!companyId) {
    return null;
  }

  const company = (await getDocument(COMPANIES_COLLECTION, companyId)) as {
    config?: CompanyRoleConfig;
  } | null;
  return (company?.config as CompanyRoleConfig | undefined) ?? null;
};

export const getResolvedCompanyConfig = async (
  companyType?: string,
  companyId?: string,
): Promise<Config> => {
  const baseConfig = getConfig(companyType);
  const roleConfig = await getCompanyRoleConfig(companyId);

  return applyRoleConfig(baseConfig, roleConfig);
};

export const saveCompanyRoleConfig = async (
  companyId: string,
  roleConfig: CompanyRoleConfig,
): Promise<void> => {
  await update(COMPANIES_COLLECTION, companyId, {
    config: removeUndefined(roleConfig),
  });
};
